import { IconWithRightMargin } from "../../Layout/Icons/IconWithRightMargin";
import { UppercaseButton } from "../../Layout/Buttons/UppercaseButton";
import { ToolbarItemProps } from "../Toolbar/ToolbarItems";
import { KENDO_BUTTON_CLASSES } from "../../Layout/Buttons/KendoButtons";
import RenderAuthorized from "../../Auth/RenderAuthorized";

export interface SingleSelectKendoGridToolbarItemProps<T> extends ToolbarItemProps {
  onClick: (item: T | undefined) => void;
  disabled?: (item: T | undefined) => boolean;
  roles?: string[];
}

export function SingleSelectKendoGridToolbarItem<T>({
  text,
  icon,
  onClick,
  selection,
  disabled = () => false,
  roles = [],
}: SingleSelectKendoGridToolbarItemProps<T> & {
  selection: T | undefined;
}) {
  return (
    <RenderAuthorized requiredRoles={roles}>
      <UppercaseButton
        type="button"
        title={text}
        className={KENDO_BUTTON_CLASSES}
        onClick={() => onClick(selection)}
        disabled={disabled(selection)}
      >
        <IconWithRightMargin icon={icon} />
        {text}
      </UppercaseButton>
    </RenderAuthorized>
  );
}
